// ----------------------------------------------------------------------

export default function Link(theme) {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
        // THE COLOUR HAS TO BE A DEFAULT PROP, NOT A STYLE (05/10/2026).
        // MUI's Link renders a Typography and passes it `color="primary"`
        // unless told otherwise, and that lands as its own class — so the
        // `root` override below never won, and every link in the portal came
        // out in the Minimal green whatever this file said. Set as a default
        // prop it is simply the starting value, so `color="inherit"` or
        // `color="error"` on a call site still beats it.
        color: 'link.default'
      },
      styleOverrides: {
        root: {
          color: theme.palette.link.default
        }
      }
    }
  };
}
